module.exports = __webpack_public_path__ + "img/chanxian.1355e3b9.png";